import { EXTERNAL_LINKS } from '@common/configs';

export const useContact = (contactName: string) => {
  const initials = contactName
    ? contactName
        .split(' ')
        .map((p) => {
          return p.charAt(0);
        })
        .join('')
        .toUpperCase()
    : '';

  const handleLetsTalk = () => {
    return window.open(EXTERNAL_LINKS.Contact, '_blank');
  };
  const handleVisitWebsite = () => {
    return window.open(EXTERNAL_LINKS['yoc.com'], '_blank');
  };

  return {
    initials,
    handleLetsTalk,
    handleVisitWebsite,
  };
};
